import { ItemShortType } from 'application/components/SelectableList/types';
import { PointStatusesMap } from 'application/pages/PointsPage/renderer/PointsToolbar/types';

import { PointShortTypeFragment } from 'domain/api/graphql/generated';

export type PointFromLocationType = {
  pointId: string;
  pointAddress: string;
};

export type StreamBindModalFilterType = {
  query?: string;
};

export type DefaultFiltersType = {
  companyIds: string[];
  playingStatuses: PointStatusesMap[];
  companyTagIds: string[];
  query?: string;
};

export type UseStreamBindModalControllerProps = {
  targetStreamId?: string;
  points: PointShortTypeFragment[];
  pointFromLocation?: PointFromLocationType;
  onFilterExecute: (filters: StreamBindModalFilterType) => Promise<void>;
};

export interface StreamBindModalState {
  selectedPoints: Map<string, ItemShortType>;
  disabledPoints: Map<string, ItemShortType>;
  searchText: string;
  isBindLoading: boolean;
}

export enum StreamBindModalActionTypes {
  SET_SELECTED_POINTS = 'setSelectedPoints',
  SET_DISABLED_POINTS = 'setDisabledPoints',
  SET_SEARCH_TEXT = 'setSearchText',
  SET_IS_BIND_LOADING = 'setIsBindLoading',
  RESET_STATE = 'resetState',
}

export type StreamBindModalAction =
  | { type: StreamBindModalActionTypes.SET_SELECTED_POINTS; selectedPoints: Map<string, ItemShortType> }
  | { type: StreamBindModalActionTypes.SET_DISABLED_POINTS; disabledPoints: Map<string, ItemShortType> }
  | { type: StreamBindModalActionTypes.SET_SEARCH_TEXT; searchText: string }
  | { type: StreamBindModalActionTypes.SET_IS_BIND_LOADING; isBindLoading: boolean }
  | { type: StreamBindModalActionTypes.RESET_STATE };
